import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import Apis from "../../Apis";
import Loading from "../../loading/Loading";
import { showAlert } from '../../ui/dialog';
import FormWizard from '../../ui/FormWizard';
import { InputField, SelectField, FormRow } from '../../ui/InputField';
import { selectSx, inputSx } from '../../ui/TableLayout';
import {
  FiUser, FiCalendar, FiSearch, FiPackage,
  FiCreditCard, FiHash, FiUsers, FiList, FiX, FiTrash2,
} from 'react-icons/fi';

const tdStyle = { fontSize: 13, padding: '10px 12px', textAlign: 'center', borderBottom: '1px solid #f1f5f9', color: '#334155' };

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};

export default function CadastrarPedido() {
  const navigate = useNavigate();
  const t = today();

  // ── state ──────────────────────────────────────────────────────
  const [dataPedido, setDataPedido]       = useState(t);
  const [dataSaidaPedido, setDataSaida]   = useState(t);
  const [cliente, setCliente]             = useState('');
  const [clienteId, setClienteId]         = useState('');
  const [idRepresentante, setIdRep]       = useState('');
  const [representantes, setRepresentantes] = useState([]);
  const [clientes, setClientes]           = useState([]);
  const [produtos, setProdutos]           = useState([]);
  const [formaPagamento, setFormaPagamento] = useState([]);

  const [descricaoProd, setDescricaoProd] = useState('');
  const [unidadeProd, setUnidadeProd]     = useState('');
  const [precoProd, setPrecoProd]         = useState('');
  const [quantidadeProd, setQtd]          = useState('');
  const [descontoProd, setDesconto]       = useState('');
  const [codigoProd, setCodigoProd]       = useState('');
  const [produtosPedidoTemp, setProdTemp] = useState([]);
  const [produtosPedido, setProdutosPedido] = useState([]);
  const [descontoTotal, setDescontoTotal] = useState(0);
  const [valorTotal, setValorTotal]       = useState(0);
  const [liquido, setLiquido]             = useState(0);

  const [pagamento, setPagamento]         = useState(0);
  const [qtdParcelas, setQtdParcelas]     = useState('');
  const [parcelas, setParcelas]           = useState([]);
  const [valorParcelas, setValorParcelas] = useState(0);

  const [loading, setLoading]             = useState(false);

  // client modal filters
  const [clienteQ, setClienteQ]           = useState('');
  const [clienteStatus, setClienteStatus] = useState('');
  const [clientePerPage, setClientePerPage] = useState(25);
  const [clienteLoading, setClienteLoading] = useState(false);

  // produto modal filters
  const [produtoQ, setProdutoQ]           = useState('');
  const [produtoStatus, setProdutoStatus] = useState('');
  const [produtoPerPage, setProdutoPerPage] = useState(25);
  const [produtoLoading, setProdutoLoading] = useState(false);

  // (kept for backward compat, unused)
  const [pesquisar, setPesquisar]         = useState('');

  // modals
  const [modalClientes, setModalClientes]   = useState(false);
  const [modalProdutos, setModalProdutos]   = useState(false);
  const [modalDeleteProd, setModalDelete]   = useState({ open: false, id: null, descricao: '' });
  const [modalParcela, setModalParcela]     = useState({ open: false, parcela: null, data: '' });

  // ── headers ────────────────────────────────────────────────────
  const headers = { 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') };

  // ── data loading ───────────────────────────────────────────────
  const fetchProdutos = (q = produtoQ, s = produtoStatus, pp = produtoPerPage) => {
    setProdutoLoading(true);
    const body = { pesquisa: q, qtd_registros: pp };
    if (s !== '') body.status = s;
    fetch(Apis.urlListarProdutos, { method: 'POST', headers, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(res => setProdutos(res.registros || []))
      .catch(() => setProdutos([]))
      .finally(() => setProdutoLoading(false));
  };

  const handleOpenProdutos = () => {
    setModalProdutos(true);
    fetchProdutos('', '', 25);
    setProdutoQ(''); setProdutoStatus(''); setProdutoPerPage(25);
  };

  useEffect(() => {
    fetch(Apis.urlListarFormasPagamento + '?pesquisa=&inativo=0&qtd_registros=200', { method: 'GET', headers })
      .then(r => r.json()).then(res => setFormaPagamento(res.registros || [])).catch(() => setFormaPagamento([]));
  }, []);

  const fetchClientes = (q = clienteQ, s = clienteStatus, pp = clientePerPage) => {
    setClienteLoading(true);
    const body = { pesquisa: q, qtd_registros: pp };
    if (s !== '') body.status = s;
    fetch(Apis.urlListarClientes, { method: 'POST', headers, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(res => setClientes(res.registros || []))
      .catch(() => setClientes([]))
      .finally(() => setClienteLoading(false));
  };

  const handleOpenClientes = () => {
    setModalClientes(true);
    fetchClientes('', '', 25);
    setClienteQ(''); setClienteStatus(''); setClientePerPage(25);
  };

  useEffect(() => {
    fetch(`${Apis.urlListarRepresentantes}?pesquisa=&status=-1&qtd_registros=200`, { method: 'GET', headers })
      .then(r => r.json()).then(res => setRepresentantes(res.registros || [])).catch(() => setRepresentantes([]));
  }, []);

  // ── handlers ───────────────────────────────────────────────────
  const alertaErro = (texto) => showAlert({ title: 'Atenção', text: texto, icon: 'error', dangerMode: true });

  const handleSelectCliente = (id) => {
    const c = clientes.find(c => c.id === id);
    if (c) { setCliente(c.nome); setClienteId(c.id); }
    setModalClientes(false);
  };

  const handleSelectProduto = (prod) => {
    setDescricaoProd(prod.descricao);
    setCodigoProd(prod.codigo);
    setUnidadeProd(prod.unidade || prod.sigla);
    setPrecoProd(prod.preco);
    setProdTemp([{ descricao: prod.descricao, codpro: prod.codigo, produto_id: prod.id, unidade_id: prod.unidade_id, unidade: prod.unidade || prod.sigla }]);
    setModalProdutos(false);
  };

  const handleAddProd = () => {
    if (produtosPedidoTemp.length === 0) { alertaErro('Selecione um produto!'); return; }
    if (quantidadeProd <= 0) { alertaErro('Quantidade deve ser maior que zero!'); return; }
    if (precoProd <= 0) { alertaErro('Preço deve ser maior que zero!'); return; }
    setParcelas([]);
    const desc  = descontoProd > 0 ? parseFloat(descontoProd) : 0;
    const total = parseFloat(precoProd) * parseFloat(quantidadeProd);
    setLiquido((parseFloat(liquido) + total).toFixed(2));
    setDescontoTotal((parseFloat(descontoTotal) + desc).toFixed(2));
    setValorTotal((parseFloat(valorTotal) + total).toFixed(2));
    setProdutosPedido([...produtosPedido, {
      id: uuidv4(), descricao: produtosPedidoTemp[0].descricao,
      codpro: produtosPedidoTemp[0].codpro, produto_id: produtosPedidoTemp[0].produto_id,
      unidade_id: produtosPedidoTemp[0].unidade_id, unidade: produtosPedidoTemp[0].unidade,
      qt: quantidadeProd, preco: precoProd, total, desconto: desc,
    }]);
    setDescricaoProd(''); setCodigoProd(''); setUnidadeProd('');
    setPrecoProd(''); setQtd(''); setDesconto(''); setProdTemp([]);
  };

  const handleDelProd = (id) => {
    setParcelas([]);
    const p = produtosPedido.find(p => p.id === id);
    if (p) {
      setDescontoTotal((parseFloat(descontoTotal) - parseFloat(p.desconto)).toFixed(2));
      setValorTotal((parseFloat(valorTotal) - parseFloat(p.total)).toFixed(2));
      setLiquido((parseFloat(liquido) - parseFloat(p.total)).toFixed(2));
    }
    setProdutosPedido(produtosPedido.filter(p => p.id !== id));
    setModalDelete({ open: false, id: null, descricao: '' });
  };

  const handleGerarParcelas = () => {
    if (valorTotal <= 0) { alertaErro('Valor do pedido deve ser maior que zero!'); return; }
    if (!qtdParcelas || qtdParcelas <= 0) { alertaErro('Informe a quantidade de parcelas!'); return; }
    const liquido = (parseFloat(valorTotal) - parseFloat(descontoTotal));
    setValorParcelas(liquido / qtdParcelas);
    const d = new Date();
    const temp = Array.from({ length: qtdParcelas }, (_, i) => {
      const dt = new Date(d); dt.setDate(dt.getDate() + 30 * (i + 1));
      return {
        parcela: i + 1,
        vencimento: `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`,
        valor: liquido / qtdParcelas,
      };
    });
    setParcelas(temp);
  };

  const handleAltDataParcela = () => {
    setParcelas(parcelas.map(p => p.parcela === modalParcela.parcela?.parcela ? { ...p, vencimento: modalParcela.data } : p));
    setModalParcela({ open: false, parcela: null, data: '' });
  };

  const handleGravar = () => {
    if (!clienteId) { alertaErro('Selecione um cliente!'); return; }
    if (valorTotal <= 0) { alertaErro('Adicione ao menos um produto!'); return; }
    setLoading(true);
    const body = {
      data: dataPedido, data_saida: dataSaidaPedido,
      forma_pagamento_id: pagamento, natureza_id: 0,
      participante_id: clienteId,
      vendedor_id: idRepresentante > 0 ? idRepresentante : 0,
      valor: liquido, desconto: descontoTotal,
      produtos: produtosPedido, parcelas,
    };
    fetch(Apis.urlCadastrarPedidoVenda, { method: 'POST', headers, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(res => {
        if (res.retorno.sucesso) navigate(`/alerta-sucesso/${res.retorno.mensagem}&listar-pedidos`);
        else alertaErro(res.retorno.mensagem);
        setLoading(false);
      })
      .catch(() => { alertaErro('Erro ao gravar pedido.'); setLoading(false); });
  };

  // ── filtered lists ─────────────────────────────────────────────
  const produtosFiltrados = produtos.filter(p =>
    !pesquisar || p.descricao.toLowerCase().includes(pesquisar.toLowerCase()) || p.codigo?.toLowerCase().includes(pesquisar.toLowerCase())
  ).slice(0, 15);

  if (loading) return <Loading />;

  return (
    <>
      {/* ── Modal: selecionar cliente ── */}
      {modalClientes && <div style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModalClientes(false)}>
        <div style={{ width: '95vw', height: '90vh', background: '#fff', borderRadius: 8, boxShadow: '0 25px 60px rgba(0,0,0,0.18)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
          {/* Header */}
          <div style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1.5px solid #f1f5f9', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>Selecionar Cliente</span>
            </div>
            <button onClick={() => setModalClientes(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 4, borderRadius: 6, color: '#94a3b8' }}>
              <FiX size={16} />
            </button>
          </div>

          {/* Toolbar */}
          <div style={{ padding: '12px 24px', display: 'flex', gap: 16, alignItems: 'center', borderBottom: '1px solid #f1f5f9', flexShrink: 0, flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
              <input
                autoFocus value={clienteQ}
                onChange={e => setClienteQ(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && fetchClientes(clienteQ, clienteStatus, clientePerPage)}
                placeholder="Buscar por nome, CPF/CNPJ…"
                style={{ ...inputSx, width: '100%', paddingRight: 36, boxSizing: 'border-box' }}
              />
              <button
                onClick={() => fetchClientes(clienteQ, clienteStatus, clientePerPage)}
                style={{ position: 'absolute', right: 1, top: 1, bottom: 1, width: 32, borderLeft: '1px solid #e5e7eb', background: '#f9fafb', border: 'none', cursor: 'pointer', borderRadius: '0 3px 3px 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <FiSearch size={13} color="#6b7280" />
              </button>
            </div>
            <select value={clienteStatus} style={selectSx}
              onChange={e => { const v = e.target.value; setClienteStatus(v); fetchClientes(clienteQ, v, clientePerPage); }}>
              <option value="">Todos os status</option>
              <option value="1">Ativos</option>
              <option value="0">Inativos</option>
            </select>
            <select value={clientePerPage} style={selectSx}
              onChange={e => { const v = Number(e.target.value); setClientePerPage(v); fetchClientes(clienteQ, clienteStatus, v); }}>
              <option value={25}>25 por página</option>
              <option value={50}>50 por página</option>
              <option value={100}>100 por página</option>
            </select>
          </div>

          {/* Table */}
          <div style={{ overflowY: 'auto', flex: 1 }}>
            {clienteLoading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0', color: '#94a3b8', fontSize: 13 }}>
                Carregando…
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f9fafb', position: 'sticky', top: 0 }}>
                    {['Cliente', 'CPF / CNPJ', 'Cidade', 'UF', 'Status'].map(h => (
                      <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#6b7280', letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: '1px solid #e5e7eb' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clientes.map((c, i) => (
                    <tr key={c.id}
                      onClick={() => handleSelectCliente(c.id)}
                      style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc', cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#edf6fb'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc'}
                    >
                      <td style={{ ...tdStyle, textAlign: 'left', textTransform: 'uppercase' }}>{c.nome}</td>
                      <td style={tdStyle}>{c.cnpj_cpf}</td>
                      <td style={tdStyle}>{c.cidade}</td>
                      <td style={tdStyle}>{c.uf}</td>
                      <td style={tdStyle}>
                        {String(c.status) === '1' && <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(16,185,129,0.1)', color: '#059669', fontSize: 11, fontWeight: 600 }}>Ativo</span>}
                        {String(c.status) === '0' && <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(239,68,68,0.1)', color: '#dc2626', fontSize: 11, fontWeight: 600 }}>Inativo</span>}
                        {String(c.status) === '2' && <span style={{ padding: '2px 8px', borderRadius: 4, background: 'rgba(245,158,11,0.1)', color: '#b45309', fontSize: 11, fontWeight: 600 }}>Bloqueado</span>}
                      </td>
                    </tr>
                  ))}
                  {clientes.length === 0 && (
                    <tr><td colSpan={5} style={{ ...tdStyle, textAlign: 'center', color: '#94a3b8' }}>Nenhum cliente encontrado</td></tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>}

      {/* ── Modal: selecionar produto ── */}
      {modalProdutos && <div style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModalProdutos(false)}>
        <div style={{ width: '95vw', height: '90vh', background: '#fff', borderRadius: 8, boxShadow: '0 25px 60px rgba(0,0,0,0.18)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
          {/* Header */}
          <div style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1.5px solid #f1f5f9', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>Selecionar Produto</span>
            </div>
            <button onClick={() => setModalProdutos(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 4, borderRadius: 6, color: '#94a3b8' }}>
              <FiX size={16} />
            </button>
          </div>

          {/* Toolbar */}
          <div style={{ padding: '12px 24px', display: 'flex', gap: 16, alignItems: 'center', borderBottom: '1px solid #f1f5f9', flexShrink: 0, flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
              <input
                autoFocus value={produtoQ}
                onChange={e => setProdutoQ(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && fetchProdutos(produtoQ, produtoStatus, produtoPerPage)}
                placeholder="Buscar por descrição ou código…"
                style={{ ...inputSx, width: '100%', paddingRight: 36, boxSizing: 'border-box' }}
              />
              <button
                onClick={() => fetchProdutos(produtoQ, produtoStatus, produtoPerPage)}
                style={{ position: 'absolute', right: 1, top: 1, bottom: 1, width: 32, borderLeft: '1px solid #e5e7eb', background: '#f9fafb', border: 'none', cursor: 'pointer', borderRadius: '0 3px 3px 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <FiSearch size={13} color="#6b7280" />
              </button>
            </div>
            <select value={produtoStatus} style={selectSx}
              onChange={e => { const v = e.target.value; setProdutoStatus(v); fetchProdutos(produtoQ, v, produtoPerPage); }}>
              <option value="">Todos os status</option>
              <option value="0">Ativos</option>
              <option value="1">Inativos</option>
            </select>
            <select value={produtoPerPage} style={selectSx}
              onChange={e => { const v = Number(e.target.value); setProdutoPerPage(v); fetchProdutos(produtoQ, produtoStatus, v); }}>
              <option value={25}>25 por página</option>
              <option value={50}>50 por página</option>
              <option value={100}>100 por página</option>
            </select>
          </div>

          {/* Table */}
          <div style={{ overflowY: 'auto', flex: 1 }}>
            {produtoLoading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0', color: '#94a3b8', fontSize: 13 }}>
                Carregando…
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f9fafb', position: 'sticky', top: 0 }}>
                    {['Produto', 'Código', 'Unid', 'Preço', 'Estoque', 'Status'].map(h => (
                      <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#6b7280', letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: '1px solid #e5e7eb' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {produtos.map((p, i) => {
                    const ativo = String(p.status) === '0';
                    return (
                      <tr key={p.id}
                        onClick={() => handleSelectProduto(p)}
                        style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc', cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#edf6fb'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc'}
                      >
                        <td style={{ ...tdStyle, textAlign: 'left', textTransform: 'uppercase' }}>{p.descricao}</td>
                        <td style={tdStyle}>{p.codigo}</td>
                        <td style={tdStyle}>{p.sigla}</td>
                        <td style={{ ...tdStyle, fontWeight: 600, color: '#10b981' }}>R$ {p.preco}</td>
                        <td style={tdStyle}>{p.estoque}</td>
                        <td style={tdStyle}>
                          <span style={{ padding: '2px 8px', borderRadius: 4, background: ativo ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: ativo ? '#059669' : '#dc2626', fontSize: 11, fontWeight: 600 }}>
                            {ativo ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                  {produtos.length === 0 && (
                    <tr><td colSpan={6} style={{ ...tdStyle, textAlign: 'center', color: '#94a3b8' }}>Nenhum produto encontrado</td></tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>}

      {/* ── Modal: confirmar exclusão de produto ── */}
      {modalDeleteProd.open && <div style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModalDelete({ open: false, id: null, descricao: '' })}>
        <div style={{ width: 420, background: '#fff', borderRadius: 6, boxShadow: '0 25px 60px rgba(0,0,0,0.18)', padding: 32 }} onClick={e => e.stopPropagation()}>
          <p style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a', marginBottom: 8 }}>Remover produto</p>
          <p style={{ color: '#64748b', fontSize: 13.5, marginBottom: 24 }}>
            Deseja remover <strong>{modalDeleteProd.descricao}</strong> do pedido?
          </p>
          <div style={{ display: 'flex', gap: 16 }}>
            <button onClick={() => setModalDelete({ open: false, id: null, descricao: '' })} style={{ flex: 1, height: 44, borderRadius: 4, background: '#f8fafc', border: '1.5px solid #e2e8f0', fontWeight: 600, fontSize: 13, cursor: 'pointer', color: '#475569' }}>
              Cancelar
            </button>
            <button onClick={() => handleDelProd(modalDeleteProd.id)} style={{ flex: 1, height: 44, borderRadius: 4, background: 'linear-gradient(135deg, #ef4444, #dc2626)', border: 'none', fontWeight: 600, fontSize: 13, cursor: 'pointer', color: '#fff' }}>
              Confirmar
            </button>
          </div>
        </div>
      </div>}

      {/* ── Modal: alterar data parcela ── */}
      {modalParcela.open && <div style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setModalParcela({ open: false, parcela: null, data: '' })}>
        <div style={{ width: 360, background: '#fff', borderRadius: 6, boxShadow: '0 25px 60px rgba(0,0,0,0.18)', padding: 32 }} onClick={e => e.stopPropagation()}>
          <p style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a', marginBottom: 24 }}>
            Alterar data — Parcela {modalParcela.parcela?.parcela}
          </p>
          <InputField label="Nova data" type="date" value={modalParcela.data}
            onChange={e => setModalParcela(prev => ({ ...prev, data: e.target.value }))} />
          <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
            <button onClick={() => setModalParcela({ open: false, parcela: null, data: '' })} style={{ flex: 1, height: 44, borderRadius: 4, background: '#f8fafc', border: '1.5px solid #e2e8f0', fontWeight: 600, fontSize: 13, cursor: 'pointer', color: '#475569' }}>
              Cancelar
            </button>
            <button onClick={handleAltDataParcela} style={{ flex: 1, height: 44, borderRadius: 4, background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)', border: 'none', fontWeight: 600, fontSize: 13, cursor: 'pointer', color: '#fff' }}>
              Salvar
            </button>
          </div>
        </div>
      </div>}

      {/* ── Wizard ── */}
      <FormWizard
        title="Pedido de Venda"
        icon={<FiPackage />}
        steps={['Cabeçalho', 'Produtos', 'Pagamento']}
        onSubmit={handleGravar}
        submitLabel="Gravar Pedido"
      >
        {/* ── Passo 1: Cabeçalho ── */}
        <>
          <FormRow>
            <div onClick={handleOpenClientes} style={{ cursor: 'pointer' }}>
              <InputField label="Cliente" required icon={<FiUser />}
                placeholder="Clique para selecionar o cliente..."
                value={cliente} readOnly />
            </div>
            <SelectField label="Vendedor" icon={<FiUsers />} value={idRepresentante} onChange={e => setIdRep(e.target.value)}>
              <option value="">— sem vendedor —</option>
              {representantes.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
            </SelectField>
          </FormRow>
          <FormRow>
            <InputField label="Data do Pedido" type="date" icon={<FiCalendar />} value={dataPedido} onChange={e => setDataPedido(e.target.value)} />
            <InputField label="Data de Saída" type="date" icon={<FiCalendar />} value={dataSaidaPedido} onChange={e => setDataSaida(e.target.value)} />
          </FormRow>
        </>

        {/* ── Passo 2: Produtos ── */}
        <>
          {/* Add product row */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px 110px 110px 100px auto', gap: 12, alignItems: 'end' }}>
            <div onClick={handleOpenProdutos} style={{ cursor: 'pointer' }}>
              <InputField label="Produto" icon={<FiSearch />}
                placeholder="Clique para buscar..."
                value={descricaoProd} readOnly />
            </div>
            <InputField label="Unidade" value={unidadeProd} disabled />
            <InputField label="Quantidade" type="number" placeholder="0" value={quantidadeProd} onChange={e => setQtd(e.target.value)} />
            <InputField label="Preço" type="number" placeholder="0,00" value={precoProd} onChange={e => setPrecoProd(e.target.value)} />
            <InputField label="Desconto" type="number" placeholder="0,00" value={descontoProd} onChange={e => setDesconto(e.target.value)} />
            <div>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: '#374151', marginBottom: 7 }}>&nbsp;</div>
              <button onClick={handleAddProd} style={{
                height: 48, padding: '0 20px', borderRadius: 4, whiteSpace: 'nowrap',
                background: '#3b82f6',
                color: '#fff', border: 'none', fontWeight: 600, fontSize: 13, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 6,
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#2563eb'}
              onMouseLeave={e => e.currentTarget.style.background = '#3b82f6'}>
                Incluir
              </button>
            </div>
          </div>

          {/* Products table */}
          {produtosPedido.length > 0 && (
            <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 4, overflow: 'hidden', marginTop: 8 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                    {['Código', 'Descrição', 'Unid', 'Qtd', 'Preço', 'Desconto', 'Total', ''].map(h => (
                      <th key={h} style={{ padding: '10px 12px', textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#6b7280', letterSpacing: '0.07em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {produtosPedido.map((p, i) => (
                    <tr key={p.id} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                      <td style={tdStyle}>{p.codpro}</td>
                      <td style={{ ...tdStyle, textAlign: 'left', textTransform: 'uppercase' }}>{p.descricao}</td>
                      <td style={tdStyle}>{p.unidade}</td>
                      <td style={tdStyle}>{p.qt}</td>
                      <td style={tdStyle}>R$ {parseFloat(p.preco).toFixed(2)}</td>
                      <td style={tdStyle}>R$ {parseFloat(p.desconto).toFixed(2)}</td>
                      <td style={{ ...tdStyle, fontWeight: 700, color: '#10b981' }}>R$ {(parseFloat(p.total) - parseFloat(p.desconto || 0)).toFixed(2)}</td>
                      <td style={tdStyle}>
                        <button onClick={() => setModalDelete({ open: true, id: p.id, descricao: p.descricao })}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 4, display: 'flex', alignItems: 'center' }}>
                          <FiTrash2 size={15} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Totals */}
          {produtosPedido.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 32, padding: '14px 20px', background: '#f8fafc', borderRadius: 4, border: '1.5px solid #e2e8f0' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Desconto</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#ef4444' }}>R$ {descontoTotal}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Total do Pedido</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#10b981' }}>R$ {(parseFloat(valorTotal) - parseFloat(descontoTotal)).toFixed(2)}</div>
              </div>
            </div>
          )}
        </>

        {/* ── Passo 3: Pagamento ── */}
        <>
          <FormRow>
            <SelectField label="Forma de Pagamento" icon={<FiCreditCard />} value={pagamento} onChange={e => setPagamento(e.target.value)}>
              <option value="0">— selecione —</option>
              {formaPagamento.map(fp => <option key={fp.id} value={fp.id}>{fp.descricao}</option>)}
            </SelectField>
            <InputField label="Quantidade de Parcelas" type="number" icon={<FiHash />}
              placeholder="Ex: 3" value={qtdParcelas} onChange={e => setQtdParcelas(e.target.value)} />
          </FormRow>

          <button onClick={handleGerarParcelas} style={{
            height: 44, padding: '0 24px', borderRadius: 4,
            background: '#3b82f6',
            color: '#fff', border: 'none', fontWeight: 600, fontSize: 13, cursor: 'pointer',
            transition: 'background 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#2563eb'}
          onMouseLeave={e => e.currentTarget.style.background = '#3b82f6'}>
            Gerar Parcelas
          </button>

          {parcelas.length > 0 && (
            <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                    {['Parcela', 'Vencimento', 'Valor'].map(h => (
                      <th key={h} style={{ padding: '10px 16px', textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#6b7280', letterSpacing: '0.07em', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {parcelas.map((p, i) => (
                    <tr key={p.parcela} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                      <td style={tdStyle}>{p.parcela}</td>
                      <td
                        onClick={() => setModalParcela({ open: true, parcela: p, data: p.vencimento })}
                        title="Clique para alterar a data"
                        style={{ ...tdStyle, cursor: 'pointer', color: '#5294b5', fontWeight: 600 }}
                      >
                        {p.vencimento.split('-').reverse().join('/')}
                      </td>
                      <td style={{ ...tdStyle, fontWeight: 700, color: '#10b981' }}>
                        R$ {parseFloat(valorParcelas).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      </FormWizard>
    </>
  );
}
